import { helper, Actions } from '@appbaseio/reactivecore';
import { _ as _taggedTemplateLiteralLoose, a as _extends } from './_rollupPluginBabelHelpers-0f24d612.js';
import VueTypes from 'vue-types';
import { componentTypes } from '@appbaseio/reactivecore/lib/utils/constants';
import { css } from 'emotion';
import styled from '@appbaseio/vue-emotion';
import 'polished';
import { p as pagination, B as Button } from './Button-91561391.js';
import { t as types } from './vueTypes-e89c8a3c.js';
import '@appbaseio/reactivecore/lib/utils/transform';
import 'redux';
import { c as connect, h as hasCustomRenderer, i as isQueryIdentical, u as updateDefaultQuery, a as isFunction, g as getComponent } from './index-cb1950b6.js';
import { C as ComponentWrapper } from './ComponentWrapper-4f85a67e.js';
import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props';
import './Title-3522ff56.js';
import { c as container } from './ListItem-8e8fb535.js';
import { c as container$1 } from './Card-6446f1b7.js';
import { F as Flex } from './Flex-8770345d.js';

var getClassName = helper.getClassName,
    handleA11yAction = helper.handleA11yAction;

function getStartPage(totalPages, currentPage, showEndPage) {
  var midValue = parseInt(totalPages / 2, 10);
  var start = currentPage - (showEndPage ? Math.ceil(midValue / 2) - 1 : midValue);
  return start > 1 ? start : 2;
}

var Pagination = {
  name: 'Pagination',
  functional: true,
  props: {
    currentPage: types.number,
    innerClass: types.style,
    pages: types.number,
    setPage: types.func,
    totalPages: types.number,
    showEndPage: VueTypes.bool,
    prevLabel: types.string,
    nextLabel: types.string
  },
  render: function render(createElement, context) {
    var h = arguments[0];
    var props = context.props;

    var onPrevPage = function onPrevPage() {
      if (props.currentPage) {
        props.setPage(props.currentPage - 1);
      }
    };

    var onNextPage = function onNextPage() {
      if (props.currentPage < props.totalPages - 1) {
        props.setPage(props.currentPage + 1);
      }
    };

    if (!props.totalPages) {
      return null;
    }

    var innerClassName = getClassName(props.innerClass, 'button');
    var primary = props.currentPage === 0;
    var className = innerClassName || primary ? innerClassName + " " + (primary ? 'active' : '') : '';

    var buildPaginationDOM = function buildPaginationDOM(position) {
      var pages = props.pages,
          currentPage = props.currentPage,
          totalPages = props.totalPages,
          setPage = props.setPage,
          showEndPage = props.showEndPage;
      var start = position === 'start' ? getStartPage(pages, currentPage, showEndPage) : Math.max(2, Math.ceil(totalPages - (pages - 1) / 2 + 1));
      var paginationButtons = [];

      if (start <= totalPages) {
        var totalPagesToShow = pages < totalPages ? start + (pages - 1) : totalPages + 1;

        if (showEndPage) {
          totalPagesToShow = position === 'start' ? start + (Math.ceil(pages / 2) - pages % 2) : totalPages + 1;
        }

        if (currentPage > totalPages - pages + 2) {
          start = Math.max(2, totalPages - pages + 2);
          totalPagesToShow = start + pages;
        }

        var _loop = function _loop(i) {
          var activeButton = currentPage === i - 1;
          var classNameBtn = innerClassName || activeButton ? innerClassName + " " + (activeButton ? 'active' : '') : '';
          var pageBtn = h(Button, {
            "class": classNameBtn,
            "attrs": {
              "primary": activeButton,
              "tabIndex": "0",
              "alt": "page-" + i
            },
            "on": {
              "keyPress": function keyPress(event) {
                return handleA11yAction(event, function () {
                  return setPage(i - 1);
                });
              },
              "click": function click() {
                return setPage(i - 1);
              }
            }
          }, [i]);

          if (i <= totalPages + 1) {
            paginationButtons.push(pageBtn);
          }
        };

        for (var i = start; i < Math.min(totalPages + 1, totalPagesToShow); i += 1) {
          _loop(i);
        }
      }

      return paginationButtons;
    };

    var buildIntermediatePaginationDom = function buildIntermediatePaginationDom() {
      var showEndPage = props.showEndPage,
          currentPage = props.currentPage,
          totalPages = props.totalPages,
          pages = props.pages;
      if (!showEndPage) return buildPaginationDOM('start');

      if (currentPage <= totalPages - pages + 2 || totalPages <= pages) {
        return buildPaginationDOM('start');
      }

      return null;
    };

    return h("div", {
      "class": pagination + " " + getClassName(props.innerClass, 'pagination')
    }, [h(Button, {
      "class": getClassName(props.innerClass, 'button') || '',
      "attrs": {
        "disabled": props.currentPage === 0,
        "tabIndex": "0"
      },
      "on": {
        "keyPress": function keyPress(event) {
          return handleA11yAction(event, onPrevPage);
        },
        "click": onPrevPage
      }
    }, [props.prevLabel || 'Prev']), h(Button, {
      "class": className,
      "attrs": {
        "primary": primary,
        "tabIndex": "0"
      },
      "on": {
        "keyPress": function keyPress(event) {
          return handleA11yAction(event, function () {
            return props.setPage(0);
          });
        },
        "click": function click() {
          return props.setPage(0);
        }
      }
    }, ["1"]), props.showEndPage && props.currentPage >= Math.floor(props.pages / 2) + !!(props.pages % 2) ? h("span", ["..."]) : null, buildIntermediatePaginationDom(), props.showEndPage && props.pages > 2 && props.currentPage <= props.totalPages - Math.ceil(props.pages * 0.75) ? h("span", ["..."]) : null, props.showEndPage && props.totalPages >= props.pages && buildPaginationDOM('end'), h(Button, {
      "class": getClassName(props.innerClass, 'button') || '',
      "attrs": {
        "disabled": props.currentPage >= props.totalPages - 1,
        "tabIndex": "0"
      },
      "on": {
        "keyPress": function keyPress(event) {
          return handleA11yAction(event, onNextPage);
        },
        "click": onNextPage
      }
    }, [props.nextLabel || 'Next'])]);
  }
};

Pagination.install = function (Vue) {
  Vue.component(Pagination.name, Pagination);
};

var _templateObject;
var PoweredByImage = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\twidth: 110px;\n"])));

var PoweredBy = {
  functional: true,
  render: function render(h) {
    return h("a", {
      "attrs": {
        "href": "https://appbase.io/",
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [h(PoweredByImage, {
      "attrs": {
        "src": "https://cdn.jsdelivr.net/gh/appbaseio/cdn@d2ec210045e59104ee5485841fa17b23fc83f097/appbase/logos/rbc-logo.svg"
      }
    })]);
  }
};

var ResultListWrapper = {
  name: 'ResultListWrapper',
  functional: true,
  render: function render(_, _ref) {
    var props = _ref.props,
        children = _ref.children;
    var h = arguments[0];
    return h("div", _mergeJSXProps([{
      "attrs": {
        "className": container
      }
    }, props]), [children]);
  }
};

ResultListWrapper.install = function (Vue) {
  Vue.component(ResultListWrapper.name, ResultListWrapper);
};

var ResultCardsWrapper = {
  name: 'ResultCardsWrapper',
  functional: true,
  render: function render(_, _ref) {
    var props = _ref.props,
        children = _ref.children;
    var h = arguments[0];
    return h("div", _mergeJSXProps([{
      "attrs": {
        "className": container$1
      }
    }, props]), [children]);
  }
};

ResultCardsWrapper.install = function (Vue) {
  Vue.component(ResultCardsWrapper.name, ResultCardsWrapper);
};

var _templateObject$1, _templateObject2;
var resultStats = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\tflex-grow: 1;\n\tfont-size: 0.82rem;\n"])));
var sortOptions = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\tcolor: #424242;\n\theight: 32px;\n\tfont-size: 0.82rem;\n\tpadding: 0 25px 0 10px;\n\tbackground: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+)\n\t\tno-repeat 95% 50%;\n\tbackground-color: #fff;\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n\tappearance: none;\n\t-webkit-border-radius: 0;\n\tborder-radius: 0;\n\tborder: 0;\n\toutline: 1px solid #ddd;\n\toutline-offset: -1px;\n"])));

var recordImpressions = Actions.recordImpressions;
var isEqual = helper.isEqual;

var debounce = function debounce(method, delay) {
  clearTimeout(method._tId); // eslint-disable-next-line

  method._tId = setTimeout(function () {
    method();
  }, delay);
};

var ImpressionTracker = {
  name: 'ImpressionTracker',
  inject: ['$$store'],
  props: {
    hits: types.hits
  },
  created: function created() {
    // Represents the list of hits returned by the query
    this.currentHits = []; // An array of hits objects
    // An object to track the recorded impressions
    // It can have the values in following shape
    // { "hit_id": { "index": "test" }}

    this.trackedIds = {}; // An object to know the the un-tracked impression i.e not recorded by BE
    // It can have the values in following shape
    // { "query_id": [{ "id": "hit_id", "index": "test"}]}

    this.waitingToBeTracked = {};
  },
  mounted: function mounted() {
    this.setCurrentHits(this.hits); // Add scroll events to track the impressions

    if (window) {
      window.addEventListener('scroll', this.tracker);
    }
  },
  destroy: function destroy() {
    // Clear the interval
    this.clearTrackerInterval();
  },
  watch: {
    hits: function hits(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        // Only compare hit ids for performance reasons
        var prevHitIds = oldVal.map(function (hit) {
          return hit._id;
        });
        var currentHitIds = newVal.map(function (hit) {
          return hit._id;
        });

        if (!isEqual(currentHitIds, prevHitIds)) {
          this.setCurrentHits(newVal);
        }
      }
    }
  },
  methods: {
    inViewPort: function inViewPort(el) {
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    setCurrentHits: function setCurrentHits(hits) {
      this.currentHits = hits; // Reset the tracked Ids for new hits

      this.trackedIds = {};

      if (hits && hits.length) {
        this.tracker(); // Run the tracker function on an interval of 1s to track the impressions for
        // non-scroll views for e.g on tab change

        this.setTrackerInterval();
      }
    },
    recordImpression: function recordImpression() {
      var _this = this;

      if (Object.keys(this.waitingToBeTracked).length) {
        var unTrackedHits = _extends({}, this.waitingToBeTracked);

        Object.keys(unTrackedHits).forEach(function (queryId) {
          if (unTrackedHits[queryId] && unTrackedHits[queryId].length) {
            _this.trackImpressions(queryId, unTrackedHits[queryId]); // Removed tracked impressions from waiting list


            delete _this.waitingToBeTracked[queryId];
          }
        });
      }
    },
    addToWaitingList: function addToWaitingList(hitObject) {
      var queryId = this.getQueryId();

      if (hitObject && queryId) {
        var impression = {
          id: hitObject._id,
          index: hitObject._index
        }; // Check if query id already present in waiting list

        if (this.waitingToBeTracked[queryId]) {
          this.waitingToBeTracked[queryId].push(impression);
        } else {
          this.waitingToBeTracked[queryId] = [impression];
        }
      }
    },
    tracker: function tracker() {
      var _this2 = this;

      if (!this.getHitIds().length) {
        this.clearTrackerInterval();
        return;
      } // only run at client-side


      if (window && document) {
        this.getHitIds().forEach(function (id) {
          var element = document.getElementById(id);

          if (element) {
            if (_this2.inViewPort(element)) {
              // Add the hit id in the list of tracked ids
              var hitObject = _this2.currentHits.find(function (hit) {
                return hit._id === id;
              });

              _this2.trackedIds[id] = true; // Add hit to waiting list to be recorded

              _this2.addToWaitingList(hitObject);
            }
          }
        });
      }

      debounce(this.recordImpression, 300);
    },
    setTrackerInterval: function setTrackerInterval() {
      this.intervalID = setInterval(this.tracker, 1000);
    },
    clearTrackerInterval: function clearTrackerInterval() {
      if (this.intervalID) {
        clearInterval(this.intervalID); // Reset interval ID

        this.intervalID = null;
      }
    },
    getQueryId: function getQueryId() {
      var state = this.$$store ? this.$$store.getState() : null;
      return state ? state.analytics.searchId : null;
    },
    getHitIds: function getHitIds() {
      var _this3 = this;

      return this.currentHits.map(function (hit) {
        return hit._id;
      }).filter(function (id) {
        return !_this3.trackedIds[id];
      });
    }
  },
  render: function render() {
    return this.$slots["default"];
  }
};
var mapDispatchToProps = {
  trackImpressions: recordImpressions
};
var ImpressionTracker$1 = connect(function () {
  return null;
}, mapDispatchToProps)(ImpressionTracker);

var setQueryOptions = Actions.setQueryOptions,
    updateQuery = Actions.updateQuery,
    loadMore = Actions.loadMore,
    setValue = Actions.setValue,
    updateComponentProps = Actions.updateComponentProps,
    setDefaultQuery = Actions.setDefaultQuery,
    recordResultClick = Actions.recordResultClick;
var isEqual$1 = helper.isEqual,
    getQueryOptions = helper.getQueryOptions,
    getClassName$1 = helper.getClassName,
    parseHits = helper.parseHits,
    getOptionsFromQuery = helper.getOptionsFromQuery,
    getCompositeAggsQuery = helper.getCompositeAggsQuery,
    getResultStats = helper.getResultStats;
var ReactiveList = {
  name: 'ReactiveList',
  components: {
    ResultListWrapper: ResultListWrapper,
    ResultCardsWrapper: ResultCardsWrapper
  },
  data: function data() {
    var props = this.$props;
    var currentPageState = 0;

    if (props.defaultPage >= 0) {
      currentPageState = props.defaultPage;
    } else if (props.currentPage) {
      currentPageState = Math.max(props.currentPage - 1, 0);
    }

    this.__state = {
      from: currentPageState * props.size,
      isLoading: true,
      currentPageState: currentPageState
    };
    return this.__state;
  },
  created: function created() {
    var _this = this;

    var _this$$props = this.$props,
        distinctField = _this$$props.distinctField,
        distinctFieldConfig = _this$$props.distinctFieldConfig,
        index = _this$$props.index; // no support for pagination and aggregationField together

    if (this.pagination && this.aggregationField) {
      console.warn('Pagination is not supported when aggregationField is present. The list will be rendered with infinite scroll');
    }

    if (this.enableAppbase && this.aggregationField && this.aggregationField !== '') {
      console.warn('Warning(ReactiveSearch): The `aggregationField` prop has been marked as deprecated, please use the `distinctField` prop instead.');
    }

    if (!this.enableAppbase && (distinctField || distinctFieldConfig)) {
      console.warn('Warning(ReactiveSearch): In order to use the `distinctField` and `distinctFieldConfig` props, the `enableAppbase` prop must be set to true in `ReactiveBase`.');
    }

    if (!this.enableAppbase && index) {
      console.warn('Warning(ReactiveSearch): In order to use the `index` prop, the `enableAppbase` prop must be set to true in `ReactiveBase`.');
    }

    if (this.defaultPage >= 0) {
      this.currentPageState = this.defaultPage;
      this.from = this.currentPageState * this.$props.size;
    }

    this.internalComponent = this.$props.componentId + "__internal";
    this.sortOptionIndex = this.defaultSortOption ? this.sortOptions.findIndex(function (s) {
      return s.label === _this.defaultSortOption;
    }) : 0;
    this.updateComponentProps(this.componentId, {
      from: this.from
    }, componentTypes.reactiveList);
    this.updateComponentProps(this.internalComponent, {
      from: this.from
    }, componentTypes.reactiveList);
  },
  props: {
    currentPage: VueTypes.number.def(0),
    includeFields: types.includeFields.def(['*']),
    // component props
    className: types.string,
    componentId: types.stringRequired,
    dataField: types.stringRequired,
    aggregationField: types.string,
    aggregationSize: VueTypes.number,
    defaultQuery: types.func,
    defaultSortOption: types.string,
    excludeFields: types.excludeFields.def([]),
    innerClass: types.style,
    listClass: VueTypes.string.def(''),
    loader: types.title,
    render: types.func,
    renderItem: types.func,
    renderNoResults: VueTypes.any.def('No Results found.'),
    renderError: types.title,
    renderResultStats: types.func,
    pages: VueTypes.number.def(5),
    pagination: VueTypes.bool.def(false),
    infiniteScroll: VueTypes.bool.def(true),
    paginationAt: types.paginationAt.def('bottom'),
    react: types.react,
    scrollOnChange: VueTypes.bool.def(true),
    showResultStats: VueTypes.bool.def(true),
    showEndPage: VueTypes.bool.def(false),
    size: VueTypes.number.def(10),
    sortBy: types.sortBy,
    sortOptions: types.sortOptions,
    URLParams: VueTypes.bool.def(false),
    prevLabel: types.string,
    nextLabel: types.string,
    distinctField: types.string,
    distinctFieldConfig: types.props,
    index: VueTypes.string
  },
  computed: {
    shouldRenderPagination: function shouldRenderPagination() {
      return this.pagination && !this.aggregationField;
    },
    totalPages: function totalPages() {
      return Math.ceil(this.total / this.$props.size) || 0;
    },
    hasPageChangeListener: function hasPageChangeListener() {
      return this.$listeners && this.$listeners.pageChange;
    },
    hasResultStatsListener: function hasResultStatsListener() {
      return this.$listeners && this.$listeners.resultStats;
    },
    stats: function stats() {
      var _this$getAllData = this.getAllData(),
          filteredResults = _this$getAllData.filteredResults;

      return _extends({}, getResultStats(this), {
        currentPage: this.currentPageState,
        displayedResults: filteredResults.length
      });
    },
    hasCustomRender: function hasCustomRender() {
      return hasCustomRenderer(this);
    },
    showInfiniteScroll: function showInfiniteScroll() {
      // Pagination has higher priority then infinite scroll
      return this.infiniteScroll && !this.shouldRenderPagination;
    }
  },
  watch: {
    sortOptions: function sortOptions(newVal, oldVal) {
      if (!isEqual$1(oldVal, newVal)) {
        this.updateQueryOptions(this.$props);
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateQueryOptions(this.$props);
      }
    },
    size: function size(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateQueryOptions(this.$props);
      }
    },
    dataField: function dataField(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateQueryOptions(this.$props);
      }
    },
    includeFields: function includeFields(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateQueryOptions(this.$props);
      }
    },
    excludeFields: function excludeFields(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateQueryOptions(this.$props);
      }
    },
    defaultQuery: function defaultQuery(newVal, oldVal) {
      if (!isQueryIdentical(newVal, oldVal, null, this.$props)) {
        var options = getQueryOptions(this.$props);
        options.from = 0;
        this.$defaultQuery = newVal(null, this.$props);

        var _ref = this.$defaultQuery || {},
            sort = _ref.sort,
            query = _ref.query;

        if (sort) {
          options.sort = this.$defaultQuery.sort;
        }

        var queryOptions = getOptionsFromQuery(this.$defaultQuery);

        if (queryOptions) {
          options = _extends({}, options, getOptionsFromQuery(this.$defaultQuery));
        } // Update calculated default query in store


        updateDefaultQuery(this.componentId, this.setDefaultQuery, this.$props);
        this.setQueryOptions(this.$props.componentId, _extends({}, options, this.getAggsQuery()), !query);
        this.updateQuery({
          componentId: this.internalComponent,
          query: query
        }, true); // reset page because of query change

        this.currentPageState = 0;
        this.from = 0;
      }
    },
    promotedResults: function promotedResults(newVal, oldVal) {
      if (!isEqual$1(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    hidden: function hidden(newVal, oldVal) {
      if (!isEqual$1(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    time: function time(newVal, oldVal) {
      if (!isEqual$1(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    hits: function hits(newVal, oldVal) {
      this.$emit('data', this.getAllData());

      if (this.shouldRenderPagination) {
        // called when page is changed
        if (this.isLoading && (oldVal || newVal)) {
          if (this.hasPageChangeListener) {
            this.$emit('pageChange', this.currentPageState + 1, this.totalPages);
            this.$emit('page-change', this.currentPageState + 1, this.totalPages);
          } else if (this.scrollOnChange) {
            window.scrollTo(0, 0);
          }
        }
      } else if (oldVal && newVal) {
        if (oldVal.length !== newVal.length || newVal.length === this.$props.total) {
          if (newVal.length < oldVal.length) {
            // query has changed
            if (this.scrollOnChange) {
              window.scrollTo(0, 0);
            }

            this.from = 0;
          }
        }
      }
    },
    rawData: function rawData(newVal, oldVal) {
      if (!isEqual$1(newVal, oldVal)) {
        this.$emit('data', this.getData());
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && newVal > 0 && newVal <= this.totalPages) {
        this.setPage(newVal - 1);
      }
    },
    infiniteScroll: function infiniteScroll(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!newVal) {
          window.addEventListener('scroll', this.scrollHandler);
        } else {
          window.removeEventListener('scroll', this.scrollHandler);
        }
      } // handle window url history change (on native back and forth interactions)

    },
    defaultPage: function defaultPage(newVal, oldVal) {
      if (this.currentPageState !== newVal && oldVal !== newVal) {
        this.setPage(newVal >= 0 ? newVal : 0);
      }
    }
  },
  mounted: function mounted() {
    if (this.defaultPage < 0 && this.currentPage > 0) {
      this.setPageURL(this.$props.componentId, this.currentPage, this.$props.componentId, false, this.URLParams);
    }

    var options = getQueryOptions(this.$props);
    options.from = this.$data.from;

    if (this.$props.sortOptions) {
      var _ref2;

      var sortField = this.$props.sortOptions[this.sortOptionIndex].dataField;
      var sortBy = this.$props.sortOptions[this.sortOptionIndex].sortBy;
      options.sort = [(_ref2 = {}, _ref2[sortField] = {
        order: sortBy
      }, _ref2)]; // To handle sort options for RS API

      this.updateComponentProps(this.componentId, {
        dataField: sortField,
        sortBy: sortBy
      }, componentTypes.reactiveList);
    } else if (this.$props.sortBy) {
      var _ref3;

      options.sort = [(_ref3 = {}, _ref3[this.$props.dataField] = {
        order: this.$props.sortBy
      }, _ref3)];
    } // Override sort query with defaultQuery's sort if defined


    this.$defaultQuery = null;

    if (this.$props.defaultQuery) {
      this.$defaultQuery = this.$props.defaultQuery();
      options = _extends({}, options, getOptionsFromQuery(this.$defaultQuery));

      if (this.$defaultQuery.sort) {
        options.sort = this.$defaultQuery.sort;
      } // Update calculated default query in store


      updateDefaultQuery(this.componentId, this.setDefaultQuery, this.$props);
    } // execute is set to false at the time of mount


    var _ref4 = this.$defaultQuery || {},
        query = _ref4.query;

    var execute = false;
    this.setQueryOptions(this.$props.componentId, _extends({}, options, this.getAggsQuery()), execute);

    if (this.$defaultQuery) {
      this.updateQuery({
        componentId: this.internalComponent,
        query: query
      }, execute);
    } else {
      this.updateQuery({
        componentId: this.internalComponent,
        query: null
      }, execute);
    } // query will be executed here


    if (this.showInfiniteScroll) {
      window.addEventListener('scroll', this.scrollHandler);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.showInfiniteScroll) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  },
  render: function render() {
    var h = arguments[0];
    var hits = this.$data.hits;
    var results = parseHits(hits) || [];
    return h("div", {
      "style": this.$props.style,
      "class": this.$props.className
    }, [this.isLoading && this.shouldRenderPagination && this.showInfiniteScroll && (this.$scopedSlots.loader || this.$props.loader), this.renderErrorComponent(), h(Flex, {
      "attrs": {
        "labelPosition": this.$props.sortOptions ? 'right' : 'left'
      },
      "class": getClassName$1(this.$props.innerClass, 'resultsInfo')
    }, [this.$props.sortOptions ? this.renderSortOptions() : null, this.$props.showResultStats && results.length ? this.renderStats() : null]), !this.isLoading && results.length === 0 ? this.renderNoResult() : null, this.shouldRenderPagination && (this.$props.paginationAt === 'top' || this.$props.paginationAt === 'both') ? h(Pagination, {
      "attrs": {
        "pages": this.$props.pages,
        "totalPages": this.totalPages,
        "currentPage": this.currentPageState,
        "setPage": this.setPage,
        "innerClass": this.$props.innerClass,
        "prevLabel": this.$props.prevLabel,
        "nextLabel": this.$props.nextLabel
      }
    }) : null, this.renderResults(), this.isLoading && !this.shouldRenderPagination ? this.$scopedSlots.loader || this.$props.loader || h("div", {
      "style": {
        textAlign: 'center',
        margin: '20px 0',
        color: '#666'
      }
    }, ["Loading..."]) : null, this.shouldRenderPagination && (this.$props.paginationAt === 'bottom' || this.$props.paginationAt === 'both') ? h(Pagination, {
      "attrs": {
        "pages": this.$props.pages,
        "totalPages": Math.ceil(this.$data.total / this.$props.size),
        "currentPage": this.currentPageState,
        "setPage": this.setPage,
        "showEndPage": this.$props.showEndPage,
        "innerClass": this.$props.innerClass,
        "prevLabel": this.$props.prevLabel,
        "nextLabel": this.$props.nextLabel
      }
    }) : null, this.url.endsWith('appbase.io') && results.length ? h(Flex, {
      "attrs": {
        "direction": "row-reverse"
      },
      "class": getClassName$1(this.$props.innerClass, 'poweredBy')
    }, [h(PoweredBy)]) : null]);
  },
  methods: {
    renderErrorComponent: function renderErrorComponent() {
      var renderError = this.$scopedSlots.renderError || this.$props.renderError;

      if (renderError && this.error && !this.isLoading) {
        return isFunction(renderError) ? renderError(this.error) : renderError;
      }

      return null;
    },
    renderResults: function renderResults() {
      var _this2 = this;

      var h = this.$createElement;
      var size = this.$props.size;
      var hits = this.$data.hits;
      var results = parseHits(hits) || [];
      var filteredResults = results;
      var renderItem = this.$scopedSlots.renderItem || this.$props.renderItem;
      var element = this.hasCustomRender ? this.getComponent() : h("div", {
        "class": this.$props.listClass + " " + getClassName$1(this.$props.innerClass, 'list')
      }, [[].concat(filteredResults).map(function (item, index) {
        return renderItem({
          item: item,
          triggerClickAnalytics: function triggerClickAnalytics() {
            return _this2.triggerClickAnalytics(_this2.currentPageState * size + index);
          }
        });
      })]); // If analytics is set to true then render with impression tracker

      return this.analytics ? h(ImpressionTracker$1, {
        "attrs": {
          "hits": filteredResults
        }
      }, [element]) : element;
    },
    updateQueryOptions: function updateQueryOptions(props) {
      var options = getQueryOptions(props);
      options.from = this.$data.from;

      if (props.sortOptions) {
        var _ref5;

        var sortOptionIndex = props.defaultSortOption ? props.sortOptions.findIndex(function (s) {
          return s.label === props.defaultSortOption;
        }) : 0;
        options.sort = [(_ref5 = {}, _ref5[props.sortOptions[sortOptionIndex].dataField] = {
          order: props.sortOptions[sortOptionIndex].sortBy
        }, _ref5)];
      } else if (props.sortBy) {
        var _ref6;

        options.sort = [(_ref6 = {}, _ref6[props.dataField] = {
          order: props.sortBy
        }, _ref6)];
      }

      this.setQueryOptions(this.$props.componentId, _extends({}, options, this.getAggsQuery()), true);
    },
    getAggsQuery: function getAggsQuery() {
      var _this$$props2 = this.$props,
          size = _this$$props2.size,
          aggregationField = _this$$props2.aggregationField;
      var afterKey = this.$data.afterKey;
      var queryOptions = {
        size: size
      };

      if (aggregationField) {
        queryOptions.aggs = getCompositeAggsQuery({
          props: this.$props,
          after: afterKey || null,
          showTopHits: true
        }).aggs;
      }

      return queryOptions;
    },
    scrollHandler: function scrollHandler() {
      if (!this.isLoading && window.innerHeight + window.pageYOffset + 300 >= document.body.scrollHeight) {
        this.loadMore();
      }
    },
    loadMore: function loadMore() {
      if (this.aggregationField && !this.afterKey) return;

      if (this.hits && !this.shouldRenderPagination && this.total > this.hits.length) {
        var value = this.$data.from + this.$props.size; // If current hits length is less than the current from then it means
        // that there are no results present.
        // It can happen because of many reasons some of them are:
        // 1. Using the `collapse` query to remove results
        // 2. Shard failure
        // In above cases infinite scroll should not load more results that can
        // cause the resetting of the `from` value

        if (this.hits.length < value) {
          return;
        }

        var options = _extends({}, getQueryOptions(this.$props), this.getAggsQuery());

        this.from = value; // Update default query to support pagination for aggregationField

        updateDefaultQuery(this.componentId, this.setDefaultQuery, this.$props);
        this.loadMoreAction(this.$props.componentId, _extends({}, options, {
          from: value
        }), true, !!this.aggregationField);
      }
    },
    setPage: function setPage(page) {
      // pageClick will be called every time a pagination button is clicked
      if (page !== this.currentPageState) {
        this.$emit('pageClick', page + 1);
        this.$emit('page-click', page + 1);
        var value = this.$props.size * page;
        var options = getQueryOptions(this.$props);
        options.from = this.$data.from;
        this.from = value;
        this.currentPageState = page;
        this.loadMoreAction(this.$props.componentId, _extends({}, options, {
          from: value
        }), false);
        this.setPageURL(this.$props.componentId, page + 1, this.$props.componentId, false, this.URLParams);
      }
    },
    renderStats: function renderStats() {
      var h = this.$createElement;
      var renderResultStats = this.$scopedSlots.renderResultStats || this.$props.renderResultStats;

      if (renderResultStats && this.$data.total) {
        return renderResultStats(this.stats);
      }

      if (this.stats.numberOfResults) {
        return h("p", {
          "class": resultStats + " " + getClassName$1(this.$props.innerClass, 'resultStats')
        }, [this.stats.numberOfResults, " results found in ", this.stats.time, "ms"]);
      }

      return null;
    },
    renderNoResult: function renderNoResult() {
      var h = this.$createElement;
      var renderNoResults = this.$scopedSlots.renderNoResults || this.$props.renderNoResults;
      return h("p", {
        "class": getClassName$1(this.$props.innerClass, 'noResults') || null
      }, [isFunction(renderNoResults) ? renderNoResults() : renderNoResults]);
    },
    handleSortChange: function handleSortChange(e) {
      var _ref7;

      var index = e.target.value; // This fixes issue #371 (where sorting a multi-result page with infinite loader breaks)

      var options = getQueryOptions(this.$props);
      options.from = 0;
      var sortField = this.$props.sortOptions[index].dataField;
      var sortBy = this.$props.sortOptions[index].sortBy;
      options.sort = [(_ref7 = {}, _ref7[sortField] = {
        order: sortBy
      }, _ref7)];
      this.sortOptionIndex = index; // To handle sort options for RS API

      this.updateComponentProps(this.componentId, {
        dataField: sortField,
        sortBy: sortBy
      }, componentTypes.reactiveList);
      this.setQueryOptions(this.$props.componentId, options, true);
      this.currentPageState = 0;
      this.from = 0;
    },
    triggerClickAnalytics: function triggerClickAnalytics(searchPosition, documentId) {
      var docId = documentId;

      if (!docId) {
        var _this$getData = this.getData(),
            data = _this$getData.data;

        var hitData = data.find(function (hit) {
          return hit._click_id === searchPosition;
        });

        if (hitData && hitData._id) {
          docId = hitData._id;
        }
      }

      this.recordResultClick(searchPosition, docId);
    },
    renderSortOptions: function renderSortOptions() {
      var h = this.$createElement;
      return h("select", {
        "class": sortOptions + " " + getClassName$1(this.$props.innerClass, 'sortOptions'),
        "attrs": {
          "name": "sort-options",
          "aria-label": "Sort options"
        },
        "on": {
          "change": this.handleSortChange
        },
        "domProps": {
          "value": this.sortOptionIndex
        }
      }, [this.$props.sortOptions.map(function (sort, index) {
        return h("option", {
          "key": sort.label,
          "domProps": {
            "value": index
          }
        }, [sort.label]);
      })]);
    },
    withClickIds: function withClickIds(results) {
      var _this$getAllData2 = this.getAllData(),
          base = _this$getAllData2.base;

      return results.map(function (result, index) {
        return _extends({}, result, {
          _click_id: base + index
        });
      });
    },
    // Shape of the object to be returned in onData & render
    getAllData: function getAllData() {
      var size = this.size,
          promotedResults = this.promotedResults,
          aggregationData = this.aggregationData,
          customData = this.customData,
          currentPage = this.currentPage,
          hits = this.hits;
      var results = parseHits(hits) || [];
      var parsedPromotedResults = parseHits(promotedResults) || [];
      var filteredResults = results;
      var base = currentPage * size;

      if (parsedPromotedResults.length) {
        var ids = parsedPromotedResults.map(function (item) {
          return item._id;
        }).filter(Boolean);

        if (ids) {
          filteredResults = filteredResults.filter(function (item) {
            return !ids.includes(item._id);
          });
        }

        filteredResults = [].concat(parsedPromotedResults, filteredResults);
      }

      return {
        results: results,
        filteredResults: filteredResults,
        customData: customData || {},
        promotedResults: parsedPromotedResults,
        aggregationData: aggregationData,
        loadMore: this.loadMore,
        base: base,
        triggerClickAnalytics: this.triggerClickAnalytics
      };
    },
    getData: function getData() {
      var _this$getAllData3 = this.getAllData(),
          filteredResults = _this$getAllData3.filteredResults,
          promotedResults = _this$getAllData3.promotedResults,
          aggregationData = _this$getAllData3.aggregationData,
          customData = _this$getAllData3.customData;

      return {
        data: this.withClickIds(filteredResults),
        aggregationData: this.withClickIds(aggregationData || []),
        promotedData: this.withClickIds(promotedResults),
        rawData: this.rawData,
        resultStats: this.stats,
        customData: customData
      };
    },
    getComponent: function getComponent$1() {
      var error = this.error,
          isLoading = this.isLoading;

      var data = _extends({
        error: error,
        loading: isLoading,
        loadMore: this.loadMore,
        // TODO: Remove in v2
        triggerAnalytics: this.triggerClickAnalytics,
        triggerClickAnalytics: this.triggerClickAnalytics,
        setPage: this.setPage
      }, this.getData());

      return getComponent(data, this);
    }
  }
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    defaultPage: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value - 1 || -1,
    hits: state.hits[props.componentId] && state.hits[props.componentId].hits,
    rawData: state.rawData[props.componentId],
    aggregationData: state.compositeAggregations[props.componentId] || [],
    promotedResults: state.promotedResults[props.componentId] || [],
    customData: state.customData[props.componentId],
    time: state.hits[props.componentId] && state.hits[props.componentId].time || 0,
    total: state.hits[props.componentId] && state.hits[props.componentId].total,
    hidden: state.hits[props.componentId] && state.hits[props.componentId].hidden,
    analytics: state.config && state.config.analytics,
    enableAppbase: state.config.enableAppbase,
    url: state.config.url,
    error: state.error[props.componentId],
    afterKey: state.aggregations[props.componentId] && state.aggregations[props.componentId][props.aggregationField] && state.aggregations[props.componentId][props.aggregationField].after_key,
    componentProps: state.props[props.componentId],
    isLoading: state.isLoading[props.componentId] || false
  };
};

var mapDispatchtoProps = {
  loadMoreAction: loadMore,
  setPageURL: setValue,
  setQueryOptions: setQueryOptions,
  updateQuery: updateQuery,
  updateComponentProps: updateComponentProps,
  setDefaultQuery: setDefaultQuery,
  recordResultClick: recordResultClick
}; // Only used for SSR

ReactiveList.generateQueryOptions = function (props) {
  // simulate default (includeFields and excludeFields) props to generate consistent query
  var options = getQueryOptions(_extends({
    includeFields: ['*'],
    excludeFields: []
  }, props));
  var size = props.size,
      dataField = props.dataField,
      defaultSortOption = props.defaultSortOption,
      sortOptionsNew = props.sortOptions,
      currentPage = props.currentPage,
      sortBy = props.sortBy;
  options.from = currentPage ? (currentPage - 1) * (size || 10) : 0;
  options.size = size || 10;

  var getSortOption = function getSortOption() {
    var _ref9;

    if (defaultSortOption) {
      var sortOption = sortOptionsNew.find(function (option) {
        return option.label === defaultSortOption;
      });

      if (sortOption) {
        var _ref8;

        return _ref8 = {}, _ref8[sortOption.dataField] = {
          order: sortOption.sortBy
        }, _ref8;
      }
    }

    return _ref9 = {}, _ref9[sortOptionsNew[0].dataField] = {
      order: sortOptionsNew[0].sortBy
    }, _ref9;
  };

  if (sortOptionsNew) {
    options.sort = [getSortOption()];
  } else if (sortBy) {
    var _ref10;

    options.sort = [(_ref10 = {}, _ref10[dataField] = {
      order: sortBy
    }, _ref10)];
  }

  return options;
};

var RLConnected = ComponentWrapper(connect(mapStateToProps, mapDispatchtoProps)(ReactiveList), {
  componentType: componentTypes.reactiveList,
  internalComponent: true
});

ReactiveList.install = function (Vue) {
  Vue.component(ReactiveList.name, RLConnected);
  Vue.component(ResultListWrapper.name, ResultListWrapper);
  Vue.component(ResultCardsWrapper.name, ResultCardsWrapper);
}; // Add componentType for SSR


ReactiveList.componentType = componentTypes.reactiveList;

export default ReactiveList;
export { RLConnected };
